<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="total"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{$t('New Datas')}}
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >
          {{total?total+' new':''}}
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->
      <b-link
        v-for="task in tasks"
        :key="task.taskId"
      >
        <b-media>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{$t('Diagnostic Tasks')}}：{{ task.diagnosisTaskIdentifier }}
            </span>
          </p>
		  <p class="media-heading">
		    <span class="font-weight-bolder">
		      {{$t('From Device')}}：{{ task.fromDeviceIdentifier }}
		    </span>
		  </p>
          <small class="notification-text">{{$t('Upload Time')}}：{{ task.taskDiagnosisUploadTime }}</small>
        </b-media>
      </b-link>

    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer"><b-button
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      block
	  @click="linkToTask"
    >{{$t('Read all datas')}}</b-button>
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BAvatar, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import { getNewDatas } from '@/api/data'


export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  setup() {
    
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      perfectScrollbarSettings,
    }
  },
  data() {
    return {
	  tasks:[],
	  total:0
	}
  },	
  created() {
  	this.getNewDatas()
  },
  methods: {
	linkToTask(){
	  this.$router.push('/diagnostic/data/list');
	},
	//获取最新任务列表
	getNewDatas(){
	  getNewDatas().then(response => {
	    this.tasks = response.data
		this.total = response.count

		setTimeout(() => {
		  this.getNewDatas()
		}, 10000)
	  })
	},
  }
}
</script>

<style>

</style>
